import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { TextInput } from 'react-admin';

interface Props {
    source: string;
    multiline?: boolean;
    topLabel?: string;
    rightLabel?: string;
    readOnly?: boolean;
}

const TextInputWithLabels = ({ source, multiline = false, topLabel, rightLabel, readOnly = false }: Props) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
        }}
    >
        <Typography
            data-cy='top-label'
            sx={{
                mb: 1,
            }}
        >
            {topLabel}
        </Typography>

        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <TextInput
                source={source}
                helperText={false}
                label={false}
                multiline={multiline}
                {...(multiline && { minRows: 4 })}
                disabled={readOnly}
                data-cy='input'
                fullWidth
            />

            {rightLabel && (
                <Typography data-cy='right-label' sx={{ ml: 1 }}>
                    {rightLabel}
                </Typography>
            )}
        </Box>
    </Box>
);

export default TextInputWithLabels;
